const TOKEN_KEY = 'token'

const existsToken = () => {
    return !!localStorage.getItem(TOKEN_KEY)
}

const getToken = () => {
    return localStorage.getItem(TOKEN_KEY)
}

const setToken = (token: string) => {
    localStorage.setItem(TOKEN_KEY, token)
}

const clearToken = () => {
    localStorage.removeItem(TOKEN_KEY)
}

export { existsToken, getToken, setToken, clearToken }
